import { render, staticRenderFns } from "./NameDisplayEditBlock.vue?vue&type=template&id=36e395af&scoped=true&"
import script from "./NameDisplayEditBlock.vue?vue&type=script&lang=js&"
export * from "./NameDisplayEditBlock.vue?vue&type=script&lang=js&"
import style0 from "./NameDisplayEditBlock.vue?vue&type=style&index=0&id=36e395af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e395af",
  null
  
)

export default component.exports